// Teacher-facing wording for SubmissionBatchErrorCode. The raw server message
// names files and page indexes, which is right for a log and wrong for a wizard —
// but it is still a better fallback than nothing, so an unrecognised code falls
// through to it.
const MESSAGES = {
  EMPTY_STUDENTS: 'Assign at least one page to a student before continuing.',
  INVALID_ANSWER:
    'One of the responses could not be sent. Remove it and add it again.',
  DUPLICATE_PAGE: 'The same page is assigned to more than one student.',
  LIMIT_EXCEEDED: 'This upload is too large. Split it into smaller batches.',
  FILE_FORBIDDEN:
    'One of the uploaded files is no longer available to you. Upload it again.',
  ASSIGNMENT_NOT_FOUND: 'This task could not be found.',
  QUESTION_NOT_FOUND: 'This draft no longer has the question these pages answer.',
  FILE_NOT_FOUND: 'One of the uploaded files is missing. Upload it again.',
  STUDENT_NOT_IN_ASSIGNMENT:
    'A student is not enrolled in a class attached to this task.',
  PAGE_INDEX_OUT_OF_RANGE: 'A page was requested beyond the end of its file.',
  DRAFT_ALREADY_SUBMITTED: 'These responses have already been added.',
  STUDENT_ALREADY_SUBMITTED:
    'A student already has a response for this task, so another cannot be uploaded for them. Remove them from this upload.',
};

/** Single home for this copy — the client raises some of these codes itself. */
export const submissionBatchCodeMessage = (code) =>
  MESSAGES[code] || 'Bulk upload failed.';

const studentName = (students, studentId) =>
  (students || []).find((student) => String(student.id) === String(studentId))
    ?.name || null;

const studentSuffix = (error, students) => {
  const name = studentName(students, error?.details?.studentId);
  return name ? `(${name})` : '';
};

export const submissionBatchErrorMessage = (error, students = []) =>
  [
    MESSAGES[error?.code] || error?.message || 'Bulk upload failed.',
    studentSuffix(error, students),
  ]
    .filter(Boolean)
    .join(' ');
